import {
  useEffect,
  useState
} from 'react';
import { useLocation, useSession } from 'hooks';
import {
  AvatarBtn,
  Container,
  NavDropdown
} from './styles';
import Div from 'ui/Div';


function AvatarDropdown({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const { pathname } = useLocation()
  const { user } = useSession()

  const { isCreators } = useLocation()

  const toggle = () => setIsOpen(prev => !prev)
  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  useEffect(() => {
    close()
  }, [pathname])


  return (
    <Container >
      <Div role='button' onClick={toggle}>
        <AvatarBtn
          src={user.profile?.avatar}
          $isActive={isOpen}
          $isCreators={isCreators}
        />
      </Div>


      <NavDropdown $isOpen={isOpen} $isCreators={isCreators}>
        { typeof children === 'function'
          ? children({ isOpen, open, close, toggle })
          : children
        }
      </NavDropdown>
    </Container>
  )
}

export default AvatarDropdown